<template>
    <component
        :is="`Template${currentTemplate}`"
        :page="page"
        :template="currentTemplate"
    ></component>
</template>
<script>
import handlePage from '~/mixins/handlePage'
export default {
    name: 'ProductsIndex',
    mixins: [handlePage]
}
</script>
